import React, { useEffect, useState } from "react";

import logo from "../assets/buzz-mobile-noicons.webp";
import CallIcon from "@mui/icons-material/Call";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AvTimerIcon from "@mui/icons-material/AvTimer";

import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import NavbarMobile from "./NavbarMobile";
import SearchFilter from "./SearchFilter";

const StyledBadge = styled(Badge)({
  "& .MuiBadge-badge": {
    right: -2,
    top: 6,
  },
});

function Header() {
  const [cartNumber, setCartNumber] = useState(0);
  const wishNumber = useSelector((state) => state.wishlist.length);
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const syncCartCount = () => {
      const storedCart = sessionStorage.getItem("cart");
      const parsedCart = storedCart ? JSON.parse(storedCart) : [];
      setCartNumber(parsedCart.length);
    };

    syncCartCount();

    const intervalId = window.setInterval(syncCartCount, 500);
    window.addEventListener("storage", syncCartCount);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("storage", syncCartCount);
    };
  }, []);

  const handleMenu = () => {
    setOpenMenu(!openMenu);

    if (!openMenu) {
      document.body.classList.add("nav-open");
    } else {
      document.body.classList.remove("nav-open");
    }
  };

  return (
    <>
      <div className="top__header__container">
        <div className="top__header__wrapper container">
          <div className="top__header__col1">
            <div className="phone-calls top__header__pill">
              <span className="top__header__icon-wrap">
                <CallIcon fontSize="small" className="icon" />
              </span>
              <div className="phone-calls__info">
                <span className="top__header__label">Контакт</span>
                <a className="header__icons" href="tel:+38976810012">
                  076-810-012
                </a>
              </div>
            </div>
            <div className="header__meta top__header__pill">
              <span className="top__header__icon-wrap">
                <AvTimerIcon />
              </span>
              <div className="top__header__meta-copy">
                <span className="top__header__label">Работно време</span>
                <span>09:00 - 19:00</span>
              </div>
            </div>
          </div>

          <div className="top__header__col2">
            <Link className="top__header__action" to="/cart" aria-label="Кошничка">
              <span className="top__header__icon-wrap top__header__icon-wrap--action">
                <StyledBadge badgeContent={cartNumber} color="success">
                  <ShoppingCartIcon />
                </StyledBadge>
              </span>
              <span className="top__header__action-text">Кошничка</span>
            </Link>

            <Link className="top__header__action" to="/wishlist" aria-label="Желби">
              <span className="top__header__icon-wrap top__header__icon-wrap--action">
                <StyledBadge badgeContent={wishNumber} color="error">
                  <FavoriteIcon />
                </StyledBadge>
              </span>
              <span className="top__header__action-text">Желби</span>
            </Link>
          </div>
        </div>
      </div>

      <div className="header__container">
        <div className="header__wrapper container">
          <div className="header__logo">
            <Link to="/" className="links">
              <img src={logo} alt="Buzz Mobile logo" />
            </Link>
          </div>

          <div className="header__nav">
            <Navbar />
            <nav className="header__mobile">
              <ul>
                <li className="fav__li">
                  <IconButton
                    aria-label="wishlist"
                    className="icon"
                    component={Link}
                    to="/wishlist"
                  >
                    <StyledBadge badgeContent={wishNumber} color="error">
                      <FavoriteIcon fontSize="medium" />
                    </StyledBadge>
                  </IconButton>
                </li>
                <li>
                  <SearchFilter fontSize="medium" />
                </li>
                <li>
                  <IconButton
                    aria-label="menu"
                    className="header__menu-button"
                    onClick={handleMenu}
                  >
                    <MenuIcon fontSize="large" />
                  </IconButton>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      {cartNumber > 0 && location.pathname !== "/cart" ? (
        <Link to="/cart" className="floating-cart links" aria-label="Open cart">
          <StyledBadge badgeContent={cartNumber} color="success">
            <ShoppingCartIcon fontSize="medium" />
          </StyledBadge>
          <span>Кошничка</span>
        </Link>
      ) : null}
      {openMenu ? <NavbarMobile handleMenu={handleMenu} /> : null}
    </>
  );
}

export default Header;
